import { graphql, readInlineData } from 'react-relay/legacy';

export const PROMO_CODE_TRADE_FIRST_WELCOME = 'TRADE1STWELCOME';

const expiringPromotionFragment = graphql`
    fragment expiringPromoMessageHelpers_expiringPromotion on Promotion @inline {
        daysRelativeToExpiration(truncate: false)
        promotionMeta {
            urgencyMessagingDisplay
            urgencyMessagingDaysBeforeExpiration
        }
    }
`;

import { expiringPromoMessageHelpers_expiringPromotion$key } from './__generated__/expiringPromoMessageHelpers_expiringPromotion.graphql';

export const shouldShowExpiringPromo = (
    promotion: expiringPromoMessageHelpers_expiringPromotion$key
): boolean => {
    const promoData = readInlineData(expiringPromotionFragment, promotion);
    const { promotionMeta } = promoData;
    const { daysRelativeToExpiration } = promoData;
    const promoDaysToExpire = Number(daysRelativeToExpiration);
    const urgencyMessagingDisplay = !!promotionMeta?.urgencyMessagingDisplay;
    const urgencyMessagingDaysBeforeExpiration =
        promotionMeta?.urgencyMessagingDaysBeforeExpiration || 0;
    return (
        urgencyMessagingDisplay &&
        promoDaysToExpire >= 0 &&
        promoDaysToExpire <= urgencyMessagingDaysBeforeExpiration
    );
};
